import { EnvConfig } from './url';

export const GoogleApiKey = EnvConfig.GOOGLE_MAPS_API_KEY;

export const mapDefaults = {
  center: {
    latitude: 28.6448,
    longitude: 77.216721,
  },
  zoom: 16,
} as const;
